// @core/api/endpoints/notifications/get_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TemplateResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Get template by ID
 * Retrieves a specific notification template by its unique identifier. Returns the full template configuration including content and variable definitions.
 */
export async function GetTemplate(
  template_id: string,
  options?: RequestOptions
): Promise<TemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.get<TemplateResponse>(requestPath, { ...requestOptions });
}
